'use strict';
var uncurryThis = require('../internals/function-uncurry-this');

module.exports = uncurryThis({}.isPrototypeOf);



//////////////////
// WEBPACK FOOTER
// ./~/handsontable/~/core-js/internals/object-is-prototype-of.js
// module id = 138
// module chunks = 0